var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8005 3.99609C14.2226 3.99609 14.5992 4.26112 14.7419 4.65837L15.2501 6.07396C15.3308 6.29657 15.4874 6.4836 15.6923 6.60218L17.1999 7.47254C17.4046 7.59066 17.6446 7.63248 17.8772 7.59059L19.3578 7.32348C19.7736 7.24788 20.192 7.44168 20.4033 7.80768L21.2036 9.18826C21.4154 9.55326 21.3754 10.0119 21.1035 10.3347L20.1321 11.4832C19.9791 11.6638 19.8951 11.8928 19.895 12.1295V13.8702C19.8951 14.1069 19.9791 14.3359 20.1321 14.5165L21.1035 15.665C21.3754 15.9878 21.4154 16.4464 21.2036 16.8114L20.4033 18.192C20.1922 18.5576 19.7743 18.7514 19.3588 18.6762L17.8782 18.4091C17.6456 18.3672 17.4056 18.409 17.2009 18.5271L15.6933 19.3975C15.4884 19.5161 15.3318 19.7031 15.2511 19.9257L14.7429 21.3413C14.6001 21.7389 14.223 22.004 13.8005 22.0036H12.1998C11.7777 22.0036 11.4011 21.7386 11.2584 21.3413L10.7502 19.9257C10.6696 19.7034 10.5134 19.5165 10.309 19.3975L8.80042 18.5271C8.59569 18.409 8.35576 18.3672 8.12314 18.4091L6.64252 18.6762C6.22675 18.7518 5.80832 18.558 5.59709 18.192L4.79675 16.8114C4.58495 16.4464 4.62498 15.9878 4.8968 15.665L5.8682 14.5165C6.02119 14.3359 6.1052 14.1069 6.1053 13.8702V12.1295C6.1052 11.8928 6.02119 11.6638 5.8682 11.4832L4.9068 10.3347C4.63498 10.0119 4.59496 9.55326 4.80676 9.18826L5.60709 7.80768C5.81819 7.44207 6.23609 7.24833 6.65153 7.32348L8.13214 7.59059C8.36476 7.63248 8.6047 7.59066 8.80942 7.47254L10.3181 6.60218C10.5225 6.48322 10.6786 6.29628 10.7592 6.07396L11.2674 4.65837C11.409 4.26421 11.7811 3.99993 12.1998 3.99609H13.8005Z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0002,
    cy: 13.0002,
    r: 2.75115,
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.4c7a1c2aa3c14a01a25be069d3e27d25.svg";
export { ForwardRef as ReactComponent };